
import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";

import { BackLink } from "@/components";

import styles from "./Medical.module.scss";
import { BenefitSearchForm } from "./BenefitSearchForm";


export const BenefitSearch: FC = () => {

  return (
    <Stack className={styles.MedicalContainer} spacing="small">
      <BackLink linkText="Patient Lookup" />
      <BenefitSearchForm />
    </Stack>
  );
};

export default BenefitSearch;
